import { Chip, styled } from '@mui/material';

import { STATUS } from '../common';

/**
 * Outlined status chip for change-request statuses — same look as the leave
 * management StatusChip, extended with "partially approved" and "cancelled".
 */
const StyledChip = styled(Chip)(({ theme, status }) => {
    const getStatusColor = () => {
        switch (status) {
            case STATUS.approved:
                return theme.palette.success.main;
            case STATUS.partiallyApproved:
                return theme.palette.info.main;
            case STATUS.rejected:
                return theme.palette.error.main;
            case STATUS.pending:
                return theme.palette.warning.main;
            case STATUS.cancelled:
                return theme.palette.cancelled.main;
            default:
                return theme.palette.grey[500];
        }
    };
    const color = getStatusColor();
    return {
        backgroundColor: 'transparent',
        color: color,
        border: `1px solid ${color}`,
        fontWeight: 600,
        textTransform: 'capitalize'
    };
});

const StatusChip = ({ status, size = 'small', ...rest }) => (
    <StyledChip label={status || STATUS.pending} status={status} size={size} {...rest} />
);

export default StatusChip;
